/*
  PLP de MASCA — comportamiento de las secciones `masca-plp-*`.

  1. "Cargar más": el botón es un link a la página siguiente (sin JavaScript
     funciona como paginación). Acá se intercepta: se pide esa página
     renderizando SOLO la sección de la grilla (?section_id=...) y se agregan sus
     cards al final. Las cards nuevas las activa masca-card-plp.js solo.
     Se usa delegación de eventos porque facets.js reemplaza la grilla entera al
     filtrar, botón incluido.
  2. Sello "Llega hoy / Llega mañana" del banner: según la cobertura de la
     dirección guardada, nunca texto fijo.
  3. Flechas del carrusel de ofertas (solo desktop; en celular se desliza).
*/
(function () {
  'use strict';

  if (window.mascaPlpCargado) return;
  window.mascaPlpCargado = true;

  /* ------------------------------------------------------------------ */
  /* 1. Cargar más                                                       */
  /* ------------------------------------------------------------------ */

  function urlDeSeccion(href, idSeccion) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', idSeccion);
    return url.toString();
  }

  document.addEventListener('click', function (evento) {
    var boton = evento.target.closest('[data-mpl-mas]');
    if (!boton) return;

    var grilla = document.getElementById('product-grid');
    if (!grilla || !grilla.dataset.id) return; // sin grilla: que navegue normal

    evento.preventDefault();
    if (boton.getAttribute('aria-busy') === 'true') return;
    boton.setAttribute('aria-busy', 'true');
    var textoOriginal = boton.textContent;
    boton.textContent = 'Cargando…';

    fetch(urlDeSeccion(boton.href, grilla.dataset.id))
      .then(function (r) {
        if (!r.ok) throw new Error('La página siguiente respondió ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevas = doc.querySelectorAll('#product-grid > li');
        nuevas.forEach(function (li) {
          grilla.appendChild(document.importNode(li, true));
        });

        // El bloque "Mostrando X de Y" + barra + botón viene ya calculado para
        // la página nueva: se reemplaza entero.
        var actual = document.querySelector('[data-mpl-mas-contenedor]');
        var siguiente = doc.querySelector('[data-mpl-mas-contenedor]');
        if (actual && siguiente) actual.replaceWith(document.importNode(siguiente, true));

        // Foco a la primera card nueva, para quien navega con teclado.
        var primera = nuevas.length ? grilla.children[grilla.children.length - nuevas.length] : null;
        var enlace = primera && primera.querySelector('a[href]:not([tabindex="-1"])');
        if (enlace) enlace.focus({ preventScroll: true });
      })
      .catch(function (error) {
        console.error('[masca-plp] no se pudo cargar más:', error);
        window.location.href = boton.href; // plan B: paginación normal
      })
      .finally(function () {
        if (document.body.contains(boton)) {
          boton.removeAttribute('aria-busy');
          boton.textContent = textoOriginal;
        }
      });
  });

  /* ------------------------------------------------------------------ */
  /* 2. Promesa de entrega del banner                                    */
  /* ------------------------------------------------------------------ */

  var ICONO_RAYO =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z"/></svg>';

  function leer(clave) {
    try {
      return localStorage.getItem(clave) || '';
    } catch (err) {
      return '';
    }
  }

  function pintarPromesa() {
    var rutas = leer('mascaRutas').split(',').map(function (r) {
      return r.trim();
    });
    var texto = '';
    if (leer('userAddress')) {
      if (rutas.indexOf('express') !== -1) texto = 'Envíos rápidos • Llega hoy';
      else if (rutas.indexOf('bodega') !== -1 || rutas.indexOf('nextday') !== -1) texto = 'Llega mañana a tu dirección';
    }
    document.querySelectorAll('[data-mpl-promesa]').forEach(function (nodo) {
      nodo.innerHTML = texto ? ICONO_RAYO + texto : '';
      nodo.hidden = !texto;
    });
  }

  document.addEventListener('masca:cobertura-actualizada', pintarPromesa);
  window.addEventListener('masca:estado', pintarPromesa);

  /* ------------------------------------------------------------------ */
  /* 3. Flechas del carrusel de ofertas                                  */
  /* ------------------------------------------------------------------ */

  function conectarCarrusel(raiz) {
    if (raiz.hasAttribute('data-mpl-listo')) return;
    raiz.setAttribute('data-mpl-listo', '');

    var pista = raiz.querySelector('[data-mpl-pista]');
    var prev = raiz.querySelector('[data-mpl-prev]');
    var next = raiz.querySelector('[data-mpl-next]');
    if (!pista) return;

    function paso() {
      return Math.max(pista.clientWidth * 0.8, 200);
    }

    function actualizar() {
      var max = pista.scrollWidth - pista.clientWidth - 2;
      if (prev) prev.disabled = pista.scrollLeft <= 2;
      if (next) next.disabled = pista.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: 'smooth' });
      });
    }
    pista.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
  }

  function iniciar() {
    pintarPromesa();
    document.querySelectorAll('[data-mpl-carrusel]').forEach(conectarCarrusel);
  }

  document.addEventListener('shopify:section:load', iniciar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
